import React, { useState, useEffect } from "react";
import StoreNav from '../StoreNav'
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { getCategories } from '../../../../functions/category';
import { getSubs } from '../../../../functions/sub';
import CategoryForm from "../../../../components/forms/CategoryForm";
import { createStorePlacement, getPlacements, deletePlacement } from "../../../../functions/placement";
import { Divider } from "antd";
import { EditOutlined, DeleteOutlined } from "@ant-design/icons";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

const Placement = () => {

    const { user } = useSelector((state) => ({ ...state }));

    const [name, setName] = useState("");
    const [values, setValues] = useState({});
    const [loading, setLoading] = useState(false);
    const [categories, setCategories] = useState([]);
    const [category, setCategory] = useState("");
    const [placements, setPlacements] = useState([]);
    // step 1
    const [keyword, setKeyword] = useState("");
    const history = useHistory()

    const queryParams = new URLSearchParams(window.location.search);
    const store = queryParams.get('store');

    useEffect(() => {
        loadCategories();
        loadSubs();
    }, []);

    const loadCategories = () =>
        getCategories().then((c) => setCategories(c.data));

    const loadSubs = () => {
        getPlacements(store)
            .then((res) => {
                setPlacements(res.data);
            })
    }


    const handleSubmit = () => {
        setLoading(true)
        createStorePlacement(values, store, user.token)
            .then((res) => {
                // console.log(res)
                console.log(res.data);
                toast.success('Added')
                setLoading(false);
                loadSubs();
                // toast.success(`"${res.data.name}" is created`);
            })
            .catch((err) => {
                console.log(err);
                setLoading(false);
                toast.error(err.response.data.err);
                if (err.response.status === 400) toast.error(err.response.data);
            });
    }

    const removePlacement = (p) => {
        if (window.confirm('Sure?')) {
            deletePlacement(store, p._id, user.token)
                .then((res) => {
                    if (res.data == 'deleted') {
                        toast.error(`${p.category.name} is deleted`)
                        loadSubs();
                    }})
        }
    }

    return (
        <div className="container-fluid mt-2">
            <div className="row mt-2">
                <div className="col-md-2">
                    <StoreNav />
                </div>
                <div className="col-md-10">
                    {loading ? (
                        <h4 className="text-danger">Loading..</h4>
                    ) : (
                            <h1>Placement Dashboard</h1>
                        )}

                    <div className="form-group">
                        <label>Parent category</label>
                        <select
                            name="category"
                            className="form-control"
                            onChange={(e) => setValues({ ...values, "category": e.target.value })}
                        >
                            <option>Please select</option>
                            {categories.length > 0 &&
                                categories.map((c) => (
                                    <option key={c._id} value={c._id}>
                                        {c.name}
                                    </option>
                                ))}
                        </select>
                    </div>

                    <div className="form-group">
                        <label>Label</label>
                        <select
                            name="label"
                            className="form-control"
                            onChange={(e) => setValues({ ...values, "name": e.target.value })}
                        >
                            <option>Please select</option>
                            <option className="select_option" value="A"> A </option>
                            <option className="select_option" value="B"> B </option>
                            <option className="select_option" value="C"> C </option>
                            <option className="select_option" value="D"> D </option>
                            <option className="select_option" value="E"> E </option>
                            <option className="select_option" value="F"> F</option>
                        </select>
                    </div>

                    <button onClick={handleSubmit} disabled={!values.name || !values.category} className="button btn button--prime button-width--med">Submit</button>

                    <Divider />

                    <table className="table table-bordered">
                        <thead className="thead-light">
                            <tr>
                                <th scope="col">Category</th>
                                <th scope="col">Name</th>
                                <th scope="col">Edit</th>
                                <th scope="col">Delete</th>
                            </tr>
                        </thead>

                        {placements.map((p) => (
                            <tbody key={p._id}>
                                <tr>
                                    <td>{p.category.name}</td>
                                    <td>{p.name}</td>

                                    <td><EditOutlined onClick={() => { history.push(`/storecharge/placements/sub?store=${store}&&category=${p.category._id}&&id=${p._id}`) }} /></td>
                                    <td><DeleteOutlined onClick={() => { removePlacement(p) }} /></td>
                                </tr>
                            </tbody>
                        ))}


                    </table>


                </div>
            </div>
        </div>
    )
}

export default Placement
